// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_w2Q","cls2":"ReportList-cls2_XOG ReportList-cls1_w2Q"};